import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { BrokerConditionStatusEnum } from 'constants/loanActionEditor';

// Read-only, partner-facing display of the broker sign-off status.
// Kept SEPARATE from SignOffStatusOptions (the sign-off ACTION dropdown) so the
// dropdown wording ("Submitted To Lender") stays unchanged while the read chip
// shows the partner-friendly "Under review" with a BLUE label.
export const BROKER_STATUS_DISPLAY = {
  [BrokerConditionStatusEnum.NEW]: { label: 'New', variant: LabelVariant.GRAY },
  [BrokerConditionStatusEnum.SUBMITTED_TO_LENDER]: {
    label: 'Under review',
    variant: LabelVariant.BLUE,
  },
  [BrokerConditionStatusEnum.SIGNED_OFF]: { label: 'Signed Off', variant: LabelVariant.GREEN },
};
